import { AxiosResponse } from "axios";
import { AxiosInstance } from "./axiosInstance";
import {
  ChallengeResponse,
  CheckExistResponse,
  CloudTokenResponse,
  FreeTrialInfo,
  GetLoginRequest,
  GetLoginResponse,
  PostCheckEmailRequest,
  PostCheckEmailResponse,
  PostCheckResellerResponse,
  PostEmailResendCordRequest,
  PostForgotEmailRequest,
  PostForgotEmailResponse,
  PostFreeTrialSignUpResponse,
  PostLoginRequest,
  PostLoginResponse,
  PostPasswordResetRequest,
  PostPasswordResetResponse,
  PostPhoneResendCordRequest,
  PostRegisterRequest,
  PostRegisterResponse,
  PostResellerSignUpRequest,
  PostResellerSignUpResponse,
  PostResellerSubmissionRequest,
  PostResellerSubmissionResponse,
  PostResendCordRequest,
  PostResendCordResponse,
  registerCredentialRequest,
  Verify2faRequest,
  Verify2faResponse,
  verifyCredentialRequest,
} from "./interfaces/authInterface.interface";
import {
  GetNoticeResponse,
  NoticeInfo,
} from "./interfaces/noticeInterface.interface";
import {
  CommonResponse,
  CustomError,
} from "./interfaces/commonInterface.interface";

const API_PATH = "/auth";
export const getLogin = async (
  payload: GetLoginRequest
): Promise<PostLoginResponse> => {
  try {
    const { data }: AxiosResponse<GetLoginResponse> = await AxiosInstance.get(
      `${API_PATH}/login?code=${encodeURIComponent(payload.code)}`
    );
    return data;
  } catch (e: any) {
    throw e;
  }
};

export const getAuthNotices = async (): Promise<NoticeInfo[]> => {
  try {
    const res: AxiosResponse<GetNoticeResponse> = await AxiosInstance.get(
      // `${API_PATH}/list?${qs.stringify(payload)}&isDisplay=true`
      `${API_PATH}/notice`
    );

    if (res.data.result) return res.data.result;
    else return [];
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getCloudToken = async ({
  accountId,
  mergedSystemId,
}: {
  accountId: string;
  mergedSystemId: string;
}): Promise<CloudTokenResponse> => {
  try {
    const { data }: AxiosResponse<CloudTokenResponse> = await AxiosInstance.get(
      `${API_PATH}/cloud/token/${accountId}/${mergedSystemId}`
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postCheckEmail = async (
  payload: PostCheckEmailRequest
): Promise<PostCheckEmailResponse> => {
  try {
    const { data }: AxiosResponse<PostCheckEmailResponse> =
      await AxiosInstance.post(`${API_PATH}/checkEmail`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postResellerSignUp = async (
  payload: PostResellerSignUpRequest
): Promise<PostResellerSignUpResponse> => {
  try {
    const { data }: AxiosResponse<PostResellerSignUpResponse> =
      await AxiosInstance.post(`${API_PATH}/reseller/signup`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postResellerSubmission = async (
  payload: PostResellerSubmissionRequest
): Promise<PostResellerSubmissionResponse> => {
  try {
    const { data }: AxiosResponse<PostResellerSubmissionResponse> =
      await AxiosInstance.post(`${API_PATH}/reseller/submit`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postCheckReseller = async (
  payload: PostCheckEmailRequest
): Promise<PostCheckResellerResponse> => {
  try {
    const { data }: AxiosResponse<PostCheckResellerResponse> =
      await AxiosInstance.post(`${API_PATH}/checkReseller`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const checkPassword = async ({
  payload,
}: {
  payload: PostLoginRequest;
}): Promise<CheckExistResponse> => {
  try {
    const { data }: AxiosResponse<CheckExistResponse> =
      await AxiosInstance.post(`${API_PATH}/checkPassword`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};

export const postLogin = async (
  payload: PostLoginRequest
): Promise<PostLoginResponse> => {
  try {
    const { data }: AxiosResponse<PostLoginResponse> = await AxiosInstance.post(
      `${API_PATH}/login`,
      payload
    );
    //  AxiosInstance.defaults.headers.common["Authorization"] = `Bearer ${data.result.accessToken}`;
    return data;
  } catch (e) {
    throw e;
  }
};

export const postVerify = async ({
  payload,
}: {
  payload: PostPhoneResendCordRequest;
}): Promise<PostResendCordResponse> => {
  try {
    const { data }: AxiosResponse<PostResendCordResponse> =
      await AxiosInstance.post(`${API_PATH}/verifyPhoneNumber`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postFreeTrialSignUp = async ({
  payload,
}: {
  payload: FreeTrialInfo;
}): Promise<PostFreeTrialSignUpResponse> => {
  try {
    const { data }: AxiosResponse<PostFreeTrialSignUpResponse> =
      await AxiosInstance.post(`${API_PATH}/freeSignUp`, payload);
    return data;
  } catch (e) {
    throw e;
  }
};

export const postVerifyEmail = async ({
  payload,
}: {
  payload: PostEmailResendCordRequest;
}): Promise<PostResendCordResponse> => {
  try {
    const { data }: AxiosResponse<PostResendCordResponse> =
      await AxiosInstance.post(`${API_PATH}/verifyEmail`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postRegister = async ({
  payload,
  token,
}: {
  payload: PostRegisterRequest;
  token: string;
}): Promise<PostRegisterResponse> => {
  try {
    const { data }: AxiosResponse<PostRegisterResponse> =
      await AxiosInstance.post(`${API_PATH}/register`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postResetPassword = async ({
  payload,
}: {
  payload: PostPasswordResetRequest;
}): Promise<AxiosResponse<PostPasswordResetResponse>> => {
  try {
    const res: AxiosResponse<PostPasswordResetResponse> =
      await AxiosInstance.post(`${API_PATH}/reset`, payload);
    return res;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postResendCode = async ({
  payload,
}: {
  payload: PostResendCordRequest;
}): Promise<PostResendCordResponse> => {
  try {
    const { data }: AxiosResponse<PostResendCordResponse> =
      await AxiosInstance.post(`${API_PATH}/resendCode`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postForgotPassword = async ({
  payload,
}: {
  payload: PostCheckEmailRequest;
}): Promise<PostCheckEmailResponse> => {
  try {
    const { data }: AxiosResponse<PostCheckEmailResponse> =
      await AxiosInstance.post(`${API_PATH}/forgotPassword`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postForgotEmail = async ({
  payload,
}: {
  payload: PostForgotEmailRequest;
}): Promise<PostForgotEmailResponse> => {
  try {
    const { data }: AxiosResponse<PostForgotEmailResponse> =
      await AxiosInstance.post(`${API_PATH}/forgotEmail`, payload);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

const headers = {
  "Content-Type": "text/plain",
};
export const postResendUser = async ({
  accountId,
  userId,
}: {
  accountId: string;
  userId: string;
}): Promise<CommonResponse> => {
  try {
    const { data }: AxiosResponse<CommonResponse> = await AxiosInstance.post(
      `${API_PATH}/resendEmail/${accountId}`,
      userId,
      { headers }
    );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postVerify2fa = async ({
  payload,
}: {
  payload: Verify2faRequest;
}): Promise<Verify2faResponse> => {
  try {
    const { data }: AxiosResponse<Verify2faResponse> = await AxiosInstance.post(
      `${API_PATH}/verify/2fa`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postRegisterChallenge = async ({
  email,
  deviceName,
  sessionName,
}: {
  email: string;
  deviceName: string;
  sessionName: string;
}): Promise<ChallengeResponse> => {
  try {
    const { data }: AxiosResponse<ChallengeResponse> = await AxiosInstance.post(
      `${API_PATH}/passkey/register/challenge`,
      { email, deviceName, sessionName }
    );
    return {
      ...data,
      result: {
        ...data.result,
        email,
        deviceName,
        sessionName,
      },
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postVerifyChallenge = async ({
  deviceName,
  sessionName,
  email,
}: {
  deviceName: string;
  sessionName: string;
  email: string;
}): Promise<ChallengeResponse> => {
  try {
    const { data }: AxiosResponse<ChallengeResponse> = await AxiosInstance.post(
      `${API_PATH}/passkey/verify/challenge`,
      { deviceName, sessionName }
    );
    return {
      ...data,
      result: {
        ...data.result,
        deviceName,
        sessionName,
        email,
      },
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const postVerifyCredential = async (
  payload: verifyCredentialRequest
): Promise<PostLoginResponse> => {
  try {
    const { data }: AxiosResponse<PostLoginResponse> = await AxiosInstance.post(
      `${API_PATH}/passkey/verify`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const putRegisterCredential = async (
  payload: registerCredentialRequest
): Promise<PostLoginResponse> => {
  try {
    const { data }: AxiosResponse<PostLoginResponse> = await AxiosInstance.put(
      `${API_PATH}/passkey/register`,
      payload
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const deletePasskey = async (
  passkeyId: string
): Promise<CommonResponse> => {
  try {
    const { data }: AxiosResponse<CommonResponse> = await AxiosInstance.delete(
      `${API_PATH}/passkey/delete`,
      {
        data: {
          passkeyId,
        },
      }
    );
    return data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
